import { Container, Navbar } from "react-bootstrap";
import "./BottomNavigation.scss";

function BottomNavigation(props) {
  return (
    <div className="bottomnav">
      <Navbar bg="light" expand="lg">
        <Container>
            &nbsp;

        </Container>
      </Navbar>
    </div>
  );
}

export default BottomNavigation;
